import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Trash14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path d='M6.25 6V11H7.75V6H6.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.25 3.25H1V4.75H2.29052L2.72492 12.5693C2.76172 13.2317 3.30958 13.75 3.973 13.75H10.027C10.6904 13.75 11.2383 13.2317 11.2751 12.5693L11.7095 4.75H13V3.25H9.75C9.75 2.42613 9.54537 1.65628 8.94454 1.05545C7.88542 -0.00367373 6.11458 -0.00367373 5.05546 1.05545C4.45463 1.65628 4.25 2.42613 4.25 3.25ZM6.11612 2.11611C5.79907 2.43316 5.75 2.82754 5.75 3.25H8.25C8.25 2.82754 8.20093 2.43316 7.88388 2.11611C7.40246 1.63469 6.59754 1.63469 6.11612 2.11611ZM10.2072 4.75H3.79283L4.20949 12.25H9.79051L10.2072 4.75Z'
      fill='currentColor'
    />
  </Svg>
);

Trash14.displayName = 'Trash14';
export default Trash14;
